import { render, staticRenderFns } from "./typedMent.vue?vue&type=template&id=6f0bdf5d&scoped=true&"
import script from "./typedMent.vue?vue&type=script&lang=js&"
export * from "./typedMent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bdf5d",
  null
  
)

export default component.exports